export default __webpack_public_path__ + "static/media/photography competition.0c0e6e47.webp";